export default __webpack_public_path__ + "static/media/BecomingInTheCity.0c43676e.JPG";